export const de = {
    GENERAL_DELETE: 'Löschen',
    GENERAL_CANCEL: 'Abbrechen',
    GENERAL_SAVE: 'Speichern',
    GENERAL_SETTINGS: 'Einstellungen',
    JSON_EDITOR_REVISION_ACTIVE: 'aktiv',
    JSON_EDITOR_REVISION_DELETE_CONFIRM: 'Revision wirklich löschen?',
    JSON_EDITOR_REVISION_SAVE_SUCCESS: 'Revision gespeichert',
    JSON_EDITOR_REVISION_SAVE_FAILURE: 'Revision wurde nicht gespeichert',
    JSON_EDITOR_REVISION_DELETE_SUCCESS: 'Revision gelöscht',
    JSON_EDITOR_REVISION_DELETE_FAILURE: 'Revision wurde nicht gelöscht',
    JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED: 'Aktive Revisionen können nicht gelöscht werden',
    JSON_EDITOR_REVISION_ACTIVATE_SUCCESS: 'Revision aktiviert',
    JSON_EDITOR_REVISION_ACTIVATE_FAILURE: 'Revision wurde nicht aktiviert',
    JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION: 'Bereits abgenommene Revision kann nicht geändert werden.',
    JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS: 'Revisionen anderer Benutzer können nicht geändert werden',
    JSON_EDITOR_INVALID_JSON: 'Ungültiges JSON',
    MISSING_APPROVAL_PERMISSION: 'Sie haben nicht die Berechtigung, Revisionen zu genehmigen.',
    DIRECTIVE_PHONE_PRESET_CONFIGURE_GLOBAL: 'Telefonnummer-Preset global konfigurieren?',
    DIRECTIVE_CHECK_BEFORE_EXPORT_ENABLED: 'Reports müssen vor dem Export an eine Integration geprüft werden',
    DIRECTIVE_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Voreinstellungen global definieren?',
    DIRECTIVE_APP_CRM_CONNECTION_DISABLED: 'CRM-Verbindung in der Visitenkartenscanner App deaktivieren',
    DIRECTIVE_EXPORT_SETTINGS_DIRECT_EXPORT: 'Adressen direkt an die ausgewählte Erweiterung (CRM) übertragen.',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Automatischer Export global konfigurieren?',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_ENABLED: 'Automatischer Export aktivieren',
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_TIMEOUT: 'Automatischer Export aufrufen nach Minuten Inaktivität',
    DIRECTIVE_SELECT_INTEGRATION_CHOOSE: 'Integrationseinstellungen',
    DIRECTIVE_SELECT_INTEGRATION_CRM_HEADER: 'CRM Systeme:',
    DIRECTIVE_SELECT_INTEGRATION_EMAIL_HEADER: 'E-Mail Integrationen:',
    DIRECTIVE_SELECT_INTEGRATION_MA_HEADER: 'Marketing automations:',
    DIRECTIVE_SELECT_INTEGRATION_OTHER_HEADER: 'Sonstige Integrationen:',
    DIRECTIVE_VISITREPORT_MANDATORY_CONFIGURE_GLOBAL: 'Kontakt-Pflichtfelder global konfigurieren?',
    INTEGRATION_MODAL_SNAPADDY_API_HEADER: 'snapAddy API Einstellungen',
    INTEGRATION_MODAL_SNAPADDY_API_ENDPOINT_URL: 'URL',
    INTEGRATION_MODAL_SNAPADDY_API_HTTP_METHOD: 'HTTP-Methode',
    INTEGRATION_MODAL_SNAPADDY_API_AUTH_HEADER: 'Authorization-Header',
    INTEGRATION_MODAL_WECLAPP_HEADER: 'Weclapp Einstellungen',
    INTEGRATION_MODAL_SUGAR_HEADER: 'SugarCRM Einstellungen',
    INTEGRATION_MODAL_SUITE_HEADER: 'SuiteCRM Einstellungen',
    INTEGRATION_MODAL_SUGAR_USE_V41: 'Ich nutze die Sugar Community Edition',
    INTEGRATION_MODAL_CENTRALSTATION_HEADER: 'CentralStationCRM Einstellungen',
    INTEGRATION_MODAL_SAPC4C_HEADER: 'SAP Sales Cloud Einstellungen',
    INTEGRATION_MODAL_SAGE_HEADER: 'Sage Einstellungen',
    INTEGRATION_MODAL_DYNAMICS_HEADER: 'Microsoft Dynamics Einstellungen',
    INTEGRATION_MODAL_ZAPIER_HEADER: 'Zapier Einstellungen',
    INTEGRATION_MODAL_SUITE_EXPORT_2: 'CRM Export 2.0 aktiviert',
    INTEGRATION_MODAL_SUITE_PLAINTEXT_PASSWORD: 'Passwort als Klartext senden (Passwort wird nicht gespeichert)',
    INTEGRATION_MODAL_GENERIC_ENDPOINT_URL: 'URL',
    INTEGRATION_MODAL_OPTIVO_HEADER: 'Episerver Campaign Einstellungen',
    INTEGRATION_MODAL_OPTIVO_AUTHTOKEN: 'Autorisierungscode',
    INTEGRATION_MODAL_OPTIVO_AUTO_EXPORT: 'Reports nach dem Prüfen automatisch nach Episerver Campaign übertragen',
    INTEGRATION_MODAL_OPTIVO_FAQ_LINK: 'https://portal.snapaddy.com/de/knowledge/episerver-campaign-autorisierungscode-und-mailingid',
    INTEGRATION_MODAL_MANDRILL_HEADER: 'Mandrill/MailChimp Einstellungen',
    INTEGRATION_MODAL_MANDRILL_API_KEY: 'API Key',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_TEMPLATE: 'Default Vorlage',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_EMAIL: 'Default Absenderemail',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_NAME: 'Default Absendername',
    INTEGRATION_MODAL_MANDRILL_FAQ_LINK: 'https://portal.snapaddy.com/de/knowledge/mandrill-api-key-und-vorlagenname',
    INTEGRATION_MODAL_RAPID_MAIL_HEADER: 'RapidMail Einstellungen',
    INTEGRATION_MODAL_RAPID_MAIL_USER_NAME: 'API Benutzer',
    INTEGRATION_MODAL_RAPID_MAIL_PASSWORD: 'API Password',
    INTEGRATION_MODAL_RAPID_MAIL_INVALID_CREDENTIALS: 'Bitte geben Sie gültige RapidMail API User Daten ein',
    INTEGRATION_MODAL_RAPID_MAIL_AUTO_EXPORT: 'Reports nach dem Prüfen automatisch nach RapidMail übertragen',
    INTEGRATION_MODAL_RAPID_MAIL_FAQ_LINK: 'https://portal.snapaddy.com/de/knowledge/rapidmail-api-benutzer-api-passwort-und-recipient-list-id',
    INTEGRATION_MODAL_HUBSPOT_HEADER: 'Hubspot Einstellungen',
    INTEGRATION_MODAL_HUBSPOT_API_KEY: 'API Key',
    INTEGRATION_MODAL_HUBSPOT_FAQ_LINK: 'https://portal.snapaddy.com/de/knowledge/hubspot-access-token',
    INTEGRATION_MODAL_SET_DEFAULT_CRM: 'Als Default-CRM setzen',
    INTEGRATION_MODAL_SALESFORCE_HEADER: 'Salesforce Einstellungen',
    INTEGRATION_MODAL_CLOSEIO_HEADER: 'Close.io Einstellungen',
    INTEGRATION_MODAL_OUTLOOK_HEADER: 'Outlook Einstellungen',
    REMOVE_SETTINGS_REQUEST: 'Wollen sie die Einstellungen wirklich löschen?',
    INT_DYNAMICS_OAUTH_LOGIN: 'Mit OAuth verbinden',
    INT_DYNAMICS_OAUTH_LOGIN_RESTRICTION: '(Nur für Dynamics CRM 365 Online)',
    INT_DYNAMICS_USE_API: 'API-Export benutzen',
    INT_DYNAMICS_USE_LINK: 'URL-Export benutzen (ohne Dublettencheck)',
    INT_DYNAMICS_WEB_SESSION: 'Vorhandene Websession nutzen',
    INT_DYNAMICS_WINDOWS: 'Windows-Login verwenden',
    INT_SAP_LOGIN_TYPE: 'Verbindunsart',
    INT_SAP_OAUTH_CLIENT_ID: 'OAuth Client ID',
    INT_SAP_OAUTH_CLIENT_SECRET: 'OAuth Client Secret',
    INT_SAP_USE_WEBSESSION: 'Bestehende Websession verwenden',
    INT_SAP_USE_OAUTH: 'OAuth 2.0 via SAML Bearer Assertion',
    INT_SAP_ENTITY_ID: 'Entity ID',
    INTEGRATION_MODAL_GENERIC_PLEASE_CHOOSE: 'Bitte wählen ...',
    Salutation: 'Anrede',
    Title: 'Titel',
    Vorname: 'Vorname',
    Nachname: 'Nachname',
    Firma: 'Firma',
    Funktion: 'Funktion',
    Straße: 'Straße',
    Adresszusatz: 'Adresszusatz',
    PLZ: 'PLZ',
    Ort: 'Ort',
    Telefon: 'Telefon',
    Mobile: 'Mobil',
    Fax: 'Fax',
    'E-Mail': 'E-Mail',
    Website: 'Website',
    Land: 'Land',
    Bundesland: 'Bundesland',
    Kontaktdaten: 'Kontaktdaten',
};
